import registry from '../../../registry';
import {
  SCREEN_RESIZE,
  BROWSER_TYPE,
  SHOW_MOBILE_SIDEBAR,
  TOGGLE_SUMMARY,
  CLOSE_SUMMARY,
  MOBILE_ROUTE_TO_DASHBOARD,
  SCREEN_ORIENTATION
} from './actions';

const uiState = {
  showMobileSidebar: false,
  showSummary: false,
  mobileRouteToDashboard: false
};

export default function ui(state = uiState, action) {
  const { type, payload } = action;

  switch (type) {
    case SCREEN_RESIZE: {
      return {
        ...state,
        ...payload
      };
    }

    case SCREEN_ORIENTATION: {
      return {
        ...state,
        ...payload
      };
    }

    case BROWSER_TYPE: {
      return {
        ...state,
        browser: {
          ...payload,
          version: Number.parseFloat(payload?.version) || 0
        }
      };
    }

    case SHOW_MOBILE_SIDEBAR: {
      return {
        ...state,
        showMobileSidebar: !state.showMobileSidebar
      };
    }

    case TOGGLE_SUMMARY:
      return {
        ...state,
        showSummary: !state.showSummary
      };

    case CLOSE_SUMMARY:
      return {
        ...state,
        showSummary: false
      };

    case MOBILE_ROUTE_TO_DASHBOARD:
      return {
        ...state,
        mobileRouteToDashboard: payload
      };

    default:
      return state;
  }
}

registry.register('ui', ui, uiState);
